/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPricingsDailyBenefitQuery = gql`
  query GetSimulationPricingsDailyBenefitQuery {
    getSimulationPricingsDailyBenefit_simulation_pricings_daily_benefit {
      collectionNeeds {
 isDutyOfAdviceSkipped  
}
      pricings {
 level  
annualPrice  
monthlyPrice  
}
      selectedLevel 
      activePolicies {
 comment  
}
    }
  }
`;

export default GetSimulationPricingsDailyBenefitQuery;
